
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Angenommen wurde der durchschnittliche Mix an Fleisch, wie er 2012 in der Schweiz konsumiert wurde. Mitberücksichtigt sind unter anderem die Futtermittelproduktion, Bestallungen, direkte Methan-Emissionen bei der Verdauung bei wiederkäuenden Tieren wie Kühen und Schafen, Infrastruktur, Transport zum Schlachthof und zum Detailhändler, etc.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;